// rego 


$(document).ready(function() {
    const $formLogin = $('form[action="/login"]');
    const $submitBtn = $('#btnLogin');

    $formLogin.on('submit', function() {
        $submitBtn
            .prop('disabled', true)
            .removeClass('btn-success')
            .addClass('btn-secondary disabled')
            .html('<i class="fa fa-spinner fa-spin mr-2"></i> Logging in...');

        // Safety net: re-enable after 15 seconds (in case of network failure)
        setTimeout(function() {
            if ($submitBtn.prop('disabled')) {
                $submitBtn
                    .prop('disabled', false)
                    .removeClass('btn-secondary disabled')
                    .addClass('btn-success')
                    .text('Login');
            }
        }, 5000);
    });

    $.ajaxSetup({
        beforeSend: function(xhr) {
            xhr.setRequestHeader($("meta[name='_csrf_header']").attr("content"), $("meta[name='_csrf']").attr("content"));
        }
    });

    var $form = $('#rego-form');
    $form.on('submit', function(e) {
        register(e, $form);
    });



    $('#phone-verification').on('submit', function(e) {
        generate_verify(e, $('#phone-verification'));
        $('#phoneNumberSent').val($('#phoneNumber').val());
    });


    // non user logged in form after a password reset
    $('#reset-password').submit(function(event) {
        event.preventDefault();
        if ($('#reset-password').valid()) {
            savePass(event);
        }
    });

    //logged in user need to provide old password
    $('#update-password-button').click(function() {

        if ($('#update-password').valid()) {
            updatePass();
        }
    });

    // request to reset password 
    $('#reset-password-request').submit(function(event) {

        resetPassRequest(event);
    });

    //	    $('#update-email').submit(function(event) {
    //	        event.preventDefault();
    //	        console.log($('#update-email').valid());
    //	    	 if($('#update-email').valid()){
    //
    //	    		 $('#update-email').submit();
    //	    	 }
    //	    });

    $('#phone-verification').validate({
        errorClass: "is-invalid",
        focusInvalid: false,
        rules: {

            phoneNumber: {
                required: true,
                digits: true
            }

        },

        errorElement: "div",
        errorPlacement: function(error, element) {
            // Add the `help-block` class to the error element
            error.addClass("form-control-feedback");
            error.addClass("text-danger");

            error.insertAfter($(element).closest('div'));

        },
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass);
            $(element).parents(".input-group").addClass("text-danger");



        },
        unhighlight: function(element, errorClass, validClass) {

            $(element).removeClass(errorClass);
            $(element).parents(".input-group").removeClass("text-danger");

        }




    });




    $.validator.addMethod("pwcheck", function(value) {
        return /[a-z]/.test(value) && /\d/.test(value);
    }, "Password must contain at least one lowercase character and a digit");
    $('#rego-form').validate({
        errorClass: "is-invalid",
        focusInvalid: false,
        rules: {

            token: {
                required: true
            },
            firstName: {
                required: true
            },
            lastName: {
                required: true
            },
            email: {
                required: true,
                email: true
            },
            password: {
                minlength: 7,
                required: true,
                pwcheck: true
            },
            matchingPassword: {
                minlength: 7,
                required: true,
                equalTo: "#password"
            },
            terms: {
                required: true
            }

        },

        errorElement: "div",
        errorPlacement: function(error, element) {

            error.addClass("form-control-feedback");
            error.addClass("text-danger");

            error.insertAfter($(element).closest('div'));

        },
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass);
            $(element).parents(".input-group").addClass("text-danger");



        },
        unhighlight: function(element, errorClass, validClass) {

            $(element).removeClass(errorClass);
            $(element).parents(".input-group").removeClass("text-danger");

        }

    });

    $('#reset-password').validate({
        errorClass: "is-invalid",
        focusInvalid: false,
        rules: {


            newPassword: {
                minlength: 7,
                required: true,
                pwcheck: true
            },
            matchingPassword: {
                minlength: 7,
                required: true,
                equalTo: "#password"
            }

        },

        errorElement: "div",
        errorPlacement: function(error, element) {

            error.addClass("form-control-feedback");
            error.addClass("text-danger");

            error.insertAfter($(element).closest('div'));

        },
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass);
            $(element).parents(".input-group").addClass("text-danger");



        },
        unhighlight: function(element, errorClass, validClass) {

            $(element).removeClass(errorClass);
            $(element).parents(".input-group").removeClass("text-danger");

        }

    });


    $('#add-device-form').validate({
        errorClass: "is-invalid",
        focusInvalid: false,
        rules: {

            email: {
                required: !$("#email-device").is(":disabled")
            },

            password: {
                minlength: 7,
                required: true,
                pwcheck: true
            },
            matchingPassword: {
                minlength: 7,
                required: true,
                equalTo: "#password"
            }

        },
        submitHandler: function(form, event) {
            event.preventDefault();

            var userDevice = $('#add-device-form').serializeJSON();
            if (userDevice.id) {

                edit_device_ajax(userDevice, deviceTable);
            } else {

                add_device_ajax(userDevice, deviceTable);
            }


        },
        errorElement: "div",
        errorPlacement: function(error, element) {

            error.addClass("form-control-feedback");
            error.addClass("text-danger");

            error.insertAfter($(element).closest('div'));

        },
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass);
            $(element).parents(".input-group").addClass("text-danger");



        },
        unhighlight: function(element, errorClass, validClass) {

            $(element).removeClass(errorClass);
            $(element).parents(".input-group").removeClass("text-danger");

        }

    });

    $('#update-email').validate({
        errorClass: "is-invalid",
        focusInvalid: false,
        rules: {

            email: {
                email: true,
                required: true
            },
            confirmEmail: {
                email: true,
                required: true,
                equalTo: "#newEmail"
            }

        },
        messages: {

            confirmEmail: {
                equalTo: "Emails do not match"
            }
        },
        errorElement: "div",
        errorPlacement: function(error, element) {

            error.addClass("form-control-feedback");
            error.addClass("text-danger");

            error.insertAfter($(element).closest('div'));

        },
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass);
            $(element).parents(".input-group").addClass("text-danger");



        },
        unhighlight: function(element, errorClass, validClass) {

            $(element).removeClass(errorClass);
            $(element).parents(".input-group").removeClass("text-danger");

        }

    });

    $('#update-password').validate({
        errorClass: "is-invalid",
        focusInvalid: false,
        rules: {
            oldPassword: {
                required: true
            },

            newPassword: {
                minlength: 7,
                required: true,
                pwcheck: true
            },
            matchingPassword: {
                minlength: 7,
                required: true,
                equalTo: "#password"
            }

        },

        errorElement: "div",
        errorPlacement: function(error, element) {

            error.addClass("form-control-feedback");
            error.addClass("text-danger");

            error.insertAfter($(element).closest('div'));

        },
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass);
            $(element).parents(".input-group").addClass("text-danger");



        },
        unhighlight: function(element, errorClass, validClass) {

            $(element).removeClass(errorClass);
            $(element).parents(".input-group").removeClass("text-danger");

        }

    });

    var options = {};
    options.ui = {
        bootstrap4: true,
        container: "#pwd-container",
        viewports: {
            progress: ".pwstrength_viewport_progress"
        },
        showVerdictsInsideProgressBar: true
    };
    options.common = {
        debug: true,
        usernameField: "#email",
        showErrors: true
    };
    if (typeof $('#password').pwstrength === "function") {
        $('#password').pwstrength(options);
    }



    //	$(":password").keyup(function(){
    //		if($("#password").val() != $("#matchPassword").val()){
    //	        $("#globalError").show().html('Passwords not matching');
    //	    }else{
    //	    	$("#globalError").html("").hide();
    //	    }
    //	});

    //	options = {
    //		    common: {minChar:6},
    ////		    ui: {
    ////		    	showVerdictsInsideProgressBar:true,
    ////		    	showErrors:true,
    ////		    	errorMessages:{
    ////		    		  wordLength: error.wordLength,
    ////		    		  wordNotEmail: error.wordNotEmail,
    ////		    		  wordSequences: error.wordSequences,
    ////		    		  wordLowercase: error.wordLowercase,
    ////		    		  wordUppercase: error.wordUppercase,
    ////		    	      wordOneNumber: error.wordOneNumber},
    ////		    		  wordOneSpecialChar: error.wordOneSpecialChar
    ////		    		
    ////		    	}
    //		};
    //	 $('#password').pwstrength(options);


    var onReCaptchaSuccess = function(response) {
        $("#captchaError").html("").hide();
    };

    var onReCaptchaExpired = function(response) {
        $("#captchaError").html("reCaptcha has expired.  Please solve a new reCaptcha").show();
        if (typeof grecaptcha !== 'undefined') {
            grecaptcha.reset();
        }
    };

});



function generate_verify(event, $form) {
    event.preventDefault();
    const $submitBtn = $('#phone-request');  // ← this is your button

    // Immediately disable to block double clicks
    $submitBtn.prop('disabled', true);

    // Remember original content and add visual feedback
    const originalHtml = $submitBtn.html();
    $submitBtn.html(originalHtml + ' <i id="reset-spinner" class="fas fa-spinner fa-spin"></i> Sending...');


    var formData = $form.serializeJSON();


    $.ajax({
        type: "POST",
        contentType: "application/json",
        url: "/phone-verification/start",
        data: JSON.stringify(formData)
    })

        .done(function() {
            msg_time_rego("alert-success", "Enter Code", "Please check your phone and enter code to confirm phone number");
            $submitBtn.prop('disabled', false).html(originalHtml);
        })
        .fail(function(xmlhttprequest, textstatus, message) {
            $submitBtn.prop('disabled', false).html(originalHtml);
            console.log("ERROR : ", xmlhttprequest);
            msg_time_rego("alert-danger", "Error!", xmlhttprequest.responseJSON.message);


        }).always(function() {
            setTimeout(() => {
                if ($submitBtn.prop('disabled')) {
                    $submitBtn.prop('disabled', false).html(originalHtml);
                }
            }, 7000); // 20 seconds
        });



}

function msg_time_rego(alertType, heading, message) {
    var hText = "";
    if (alertType === "alert-danger") {
        hText = "class='alert-danger'";
    } else if (alertType === "alert-warning") {
        hText = "class='alert-warning'";
    } else if (alertType === "alert-success") {
        hText = "class='alert-success'";
    } else if (alertType === "alert-info") {
        hText = "class='alert-info'";
    }
    $('.feedback').append('<div class="alert ' + alertType + ' alert-dismissible fade show" role="alert"> <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> <h4 ' + hText + '>' + heading + '</h4> ' + message + ' </div>');
    setTimeout(function() {
        $(".alert-dismissible").alert('close');
    }, 4000);

}

function register(event, $form) {
    event.preventDefault();


    // Get the submit button once (assuming it has id="btnLogin" or change to correct ID)
    const $submitBtn = $('#btnLogin');  // ← adjust selector if the registration button has a different ID

    // Immediately disable the button to block double clicks
    $submitBtn.prop('disabled', true);

    // Optional: Give visual feedback (spinner + text change)
    const originalText = $submitBtn.html();  // remember original content
    $submitBtn.html(originalText + ' <i id="submit-spinner" class="fas fa-spinner fa-spin"></i> Registering...');

    if ($('#rego-form').valid()) {
        //	$('#btnLogin').append(' <i id="submit-spinner" class="fas fa-spinner fa-spin"></i> ');
        $(".alert").html("").hide();
        $(".error-list").html("");

        if (typeof grecaptcha !== 'undefined') {
            var resp = grecaptcha.getResponse();
            if (resp.length == 0) {
                $("#captchaError").show().html("Please verify that you are not a robot.");
                $submitBtn.prop('disabled', false).html(originalText);
                return;
            }
        }
        var formData = $form.serializeJSON();
        formData.gRecaptchaResponse = grecaptcha.getResponse();


        $.ajax({
            type: "POST",
            contentType: "application/json",
            url: "/user/registrationCaptcha",
            data: JSON.stringify(formData),
            dataType: 'json'
        })
            .done(function(response) {

                if (response.message == "success") {
                    window.location.href = "/successRegister.html";
                }
            })

            .fail(function(data) {
                console.log("ERROR : ", data);
                $('#submit-spinner').remove();
                $submitBtn.prop('disabled', false).html(originalText);
                grecaptcha.reset();


                msg_time_rego("alert-danger", "Error!", data.responseJSON.message);


            })
            .always(function() {
                // This runs on both success and failure
                setTimeout(() => {
                    if ($submitBtn.prop('disabled')) {
                        $submitBtn.prop('disabled', false).html(originalText);
                    }
                }, 7000); // 20 seconds safety net
            });
    } else {
        // If validation fails → re-enable immediately
        $submitBtn.prop('disabled', false).html(originalText);
    }

}


function updatePass() {

    $(".alert").html("").hide();
    $(".error-list").html("");
    var formData = $('#update-password').serializeJSON();
    $.ajax({
        type: "POST",
        contentType: "application/json",
        url: "/updatePasswordPost",
        data: JSON.stringify(formData),
        dataType: "json"
    })

        .done(function(data) {

            sessionStorage.setItem("updatedAccount", "password updated");
            window.location.href = "/account";
        })
        .fail(function(data) {


            if (data.responseJSON.errors) {
                var errors = "";
                errors = '<table id="error-table"><th>Message</th><th>Field</th><tbody>';


                for (var i = 0;i < data.responseJSON.errors.length;i++) {
                    errors = errors + '<tr><td>' + data.responseJSON.errors[i].defaultMessage + '</td></tr>';
                }

                errors = errors + '</tbody></table>';
                msg_time_rego("alert-danger", "Error", data.responseJSON.message + " " + errors);

            } else if (data.responseJSON.message) {
                msg_time_rego("alert-danger", "Error", data.responseJSON.message);
            }
        });
}

function resetPassRequest(event) {
    event.preventDefault();

    // Select the submit button (adjust selector if needed)
    const $submitBtn = $('#resetPassword');  // ← this is your button

    // Immediately disable to block double clicks
    $submitBtn.prop('disabled', true);

    // Remember original content and add visual feedback
    const originalHtml = $submitBtn.html();
    $submitBtn.html(originalHtml + ' <i id="reset-spinner" class="fas fa-spinner fa-spin"></i> Sending...');


    if (typeof grecaptcha !== 'undefined') {
        var resp = grecaptcha.getResponse();
        if (resp.length == 0) {
            $("#captchaError").show().html("Please verify that you are not a robot.");
            // Restore on early exit (reCAPTCHA missing)
            $submitBtn.prop('disabled', false).html(originalHtml);
            return;
        }
    }

    var email = $("#email").val();
    var obj = {};
    obj.email = email;
    obj.gRecaptchaResponse = grecaptcha.getResponse();
    $('#resetPassword').append(' <i id="reset-spinner" class="fas fa-spinner fa-spin"></i> ');

    $.ajax({
        type: "POST",
        contentType: "application/json",
        url: "/user/resetPasswordRequest",
        data: JSON.stringify(obj),
        dataType: 'json'
    })
        .done(function(data) {
            window.location.href = "/login?message=" + data.message;
        })
        .fail(function(jqXHR) {
            console.log(jqXHR)
            $('#reset-spinner').remove();
            $submitBtn.prop('disabled', false).html(originalHtml);

            msg_time_rego("alert-danger", "Error!", jqXHR.responseJSON.message);
        })
        .always(function() {
            setTimeout(() => {
                if ($submitBtn.prop('disabled')) {
                    $submitBtn.prop('disabled', false).html(originalHtml);
                }
            }, 7000);
        });
}

function savePass(event) {

    $(".alert").html("").hide();
    $(".error-list").html("");
    //    if($("#password").val() != $("#matchPassword").val()){
    //        $("#globalError").show().html(/*[[#{PasswordMatches.user}]]*/);
    //        return;
    //    }

    var formData = $('#reset-password').serializeJSON();

    $.ajax({
        type: "POST",
        contentType: "application/json",
        url: "/user/saveResetPassword",
        data: JSON.stringify(formData),
        dataType: 'json'
    })
        .done(function(data) {
            window.location.href = "/login?message=" + data.message;
        })
        .fail(function(data) {

            if (data.responseJSON.errors) {
                var errors = "";
                errors = '<table id="error-table"><th>Message</th><th>Field</th><tbody>';


                for (var i = 0;i < data.responseJSON.errors.length;i++) {
                    errors = errors + '<tr><td>' + data.responseJSON.errors[i].defaultMessage + '</td></tr>';
                }

                errors = errors + '</tbody></table>';
                msg_time_rego("alert-danger", "Error", data.responseJSON.message + " " + errors);

            } else if (data.responseJSON.message) {
                window.location.href = "/login?message=" + data.responseJSON.message;
            }


        });

}


function msg_time_rego(alertType, heading, message) {
    var hText = "";
    if (alertType === "alert-danger") {
        hText = "class='alert-danger'";
    } else if (alertType === "alert-warning") {
        hText = "class='alert-warning'";
    } else if (alertType === "alert-success") {
        hText = "class='alert-success'";
    } else if (alertType === "alert-info") {
        hText = "class='alert-info'";
    }
    $('.feedback').append('<div class="alert ' + alertType + ' alert-dismissible fade show" role="alert"> <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> <h4 ' + hText + '>' + heading + '</h4> ' + message + ' </div>');
    setTimeout(function() {
        $(".alert-dismissible").alert('close');
    }, 8000);

}



